<template>
  <div class="dialog_sueecss_pc">
    <div class="sueecss_box">
      <div class="dialog-close">
        <i class="el-icon-close" @click="() => this.$emit('closeform')"></i>
      </div>
      <div class="tip">
        <img class="sueecss-icon" :src="require('@/assets/images/sueecss-icon.png')" />
        <h4 style="margin-left: 13px">提交成功！</h4>
      </div>
      <div class="title">
        <p>客服人员e小宝将在1个工作日内与您取得联系开通试用哟</p>
      </div>
      <div class="focus">
        <img class="code" :src="require('@/assets/images/code.png')" />
        <p>关注专属顾问</p>
        <p>获取1份数字化报告</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.dialog_sueecss_pc {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.45);
}
.dialog-close {
  width: 100px;
  height: 100px;
  background: url('../../../../assets/images/trial_dialog_close_bg.png') top right / cover no-repeat;
  position: absolute;
  top: 0;
  right: 0;
}

.sueecss_box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 460px;
  height: 500px;
  padding: 0 50px;
  font-size: 14px;
  box-shadow: 6px 6px 13px 10px rgba(2, 6, 11, 0.23);
  background: #fff;
  color: #666b80;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  i {
    position: absolute;
    top: 12px;
    right: 14px;
    font-size: 24px;
    cursor: pointer;
  }
  .tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 80px;
    .sueecss-icon {
      width: 60px;
      height: 60px;
      margin-bottom: 12px;
    }
    h4 {
      font-size: 18px;
      color: #32373f;
      font-weight: 700;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }
  .title {
    width: 100%;
    margin-top: 18px;
    text-align: center;
  }
  .focus {
    margin-top: 36px;
    margin-bottom: 70px;
    text-align: center;
    .code {
      width: 130px;
      height: 130px;
      margin-bottom: 9px;
    }
  }
}
</style>
